import { render, staticRenderFns } from "./WabaSupsisMessageTemplateStatusUpdate.vue?vue&type=template&id=19f44e48&scoped=true"
import script from "./WabaSupsisMessageTemplateStatusUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisMessageTemplateStatusUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisMessageTemplateStatusUpdate.vue?vue&type=style&index=0&id=19f44e48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f44e48",
  null
  
)

export default component.exports